"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.customImagePattern = exports.convertDesignTokenFromRGBToHex = exports.converArrToFilerOptions = exports.checkIsIOSSafari = exports.checkIfDuplicateExists = void 0;
exports.debounce = debounce;
exports.deepCopy = deepCopy;
exports.formatToRelativeDate = exports.formatToISOString = exports.formatDateFromGivenDay = exports.findStyledColor = exports.filterGroupFlatten = void 0;
exports.generatePaginationConfiguration = generatePaginationConfiguration;
exports.getRandomNumber = void 0;
exports.getRange = getRange;
exports.isObject = exports.isEmpty = exports.isArray = exports.groupBy = exports.getWindowWidth = exports.getWindowHeight = void 0;
exports.kebabCase = kebabCase;
exports.textSearchOnArrayOfObjectsBasedOnKey = exports.sleep = exports.scrollWindow = exports.scrollToElement = exports.parseJwt = exports.merge = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _dateFns = require("date-fns");
var _index = _interopRequireDefault(require("../styles/colors/index"));
//@ts-nocheck
// Helpers
// import copy from 'copy-to-clipboard';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const ColorConvert = require('color');
const sleep = timeout => new Promise(resolve => setTimeout(resolve, timeout));
exports.sleep = sleep;
const groupBy = (data, groupByKey) => {
  if (!data.length || !Array.isArray(data)) return null;
  const groupedData = data.reduce((prev, curr) => {
    if (!prev[curr[groupByKey]]) prev[curr[groupByKey]] = [];
    prev[curr[groupByKey]].push(curr);
    return prev;
  }, {});
  return groupedData;
};
exports.groupBy = groupBy;
const converArrToFilerOptions = arr => {
  return arr.map(i => ({
    label: i,
    value: i
  }));
};
exports.converArrToFilerOptions = converArrToFilerOptions;
const checkIsIOSSafari = () => {
  const ua = window.navigator.userAgent;
  const iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
  const webkit = !!ua.match(/WebKit/i);
  const iOSSafari = iOS && webkit && !ua.match(/CriOS/i);
  return iOSSafari;
};
exports.checkIsIOSSafari = checkIsIOSSafari;
const isEmpty = obj => {
  for (const prop in obj) {
    // if (obj['hasOwnProperty'](prop)) return false;
    if (Object.prototype.hasOwnProperty.call(obj, prop)) return false;
  }
  return true;
};
exports.isEmpty = isEmpty;
const isObject = obj => {
  return !!obj && obj.constructor === Object;
};
exports.isObject = isObject;
const isArray = arr => {
  return !!arr && arr.constructor === Array;
};
exports.isArray = isArray;
function debounce(func) {
  const wait = rest.length <= 1 || rest[1] === undefined ? 100 : rest[1];
  let timeout = void 0;
  return function () {
    const _len = rest.length,
      args = Array(_len);
    for (let _key = 0; _key < _len; _key++) {
      args[_key] = rest[_key];
    }
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      func.apply(this, args);
    }, wait);
  };
}
function getRange() {
  let startAt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  let end = arguments.length > 1 ? arguments[1] : undefined;
  return (0, _toConsumableArray2["default"])(Array(end).keys()).map(i => i + startAt);
}
function generatePaginationConfiguration(selected, pageCount) {
  const config = {
    left: [],
    right: [],
    breakView: null,
    breakViewIndex: 0
  };
  const items = [];
  const pageRangeDisplayed = 2;
  const marginPagesDisplayed = 3;
  const breakLabel = '...';
  if (pageCount <= pageRangeDisplayed) {
    for (let index = 0; index < pageCount; index++) {
      items.push(index);
      config.left.push(index);
    }
  } else {
    let leftSide = pageRangeDisplayed / 2;
    let rightSide = pageRangeDisplayed - leftSide;
    // If the selected page index is on the default right side of the pagination,
    // we consider that the new right side is made up of it (= only one break element).
    // If the selected page index is on the default left side of the pagination,
    // we consider that the new left side is made up of it (= only one break element).
    if (selected > pageCount - pageRangeDisplayed / 2) {
      rightSide = pageCount - selected;
      leftSide = pageRangeDisplayed - rightSide;
    } else if (selected < pageRangeDisplayed / 2) {
      leftSide = selected;
      rightSide = pageRangeDisplayed - leftSide;
    }
    let index;
    let page;
    let breakView;
    for (index = 0; index < pageCount; index++) {
      page = index + 1;
      // If the page index is lower than the margin defined,
      // the page has to be displayed on the left side of
      // the pagination.
      if (page <= marginPagesDisplayed) {
        items.push(index);
        config.left.push(index);
        continue;
      }
      // If the page index is greater than the page count
      // minus the margin defined, the page has to be
      // displayed on the right side of the pagination.
      if (page > pageCount - marginPagesDisplayed) {
        //   items.push(createPageView(index));
        items.push(index);
        config.right.push(index);
        continue;
      }
      // If the page index is near the selected page index
      // and inside the defined range (pageRangeDisplayed)
      // we have to display it (it will create the center
      // part of the pagination).
      if (index >= selected - leftSide && index <= selected + rightSide) {
        items.push(index);
        config.left.push(index);
        continue;
      }
      // If the page index doesn't meet any of the conditions above,
      // we check if the last item of the current 'items' array
      // is a break element. If not, we add a break element, else,
      // we do nothing (because we don't want to display the page).
      if (breakLabel && items[items.length - 1] !== breakView) {
        items.push(breakView);
        breakView = 'true';
        config.breakView = breakView;
        config.breakViewIndex = index;
      }
    }
  }
  return config;
}
const getRandomNumber = () => {
  return Math.floor(Math.random() * 100 + 1);
};
exports.getRandomNumber = getRandomNumber;
const scrollWindow = () => {
  window.scrollTo(0, 0);
};
exports.scrollWindow = scrollWindow;
const checkIfDuplicateExists = arr => {
  if (!(arr === null || arr === void 0 ? void 0 : arr.length)) return false;
  return new Set(arr).size !== arr.length;
};
exports.checkIfDuplicateExists = checkIfDuplicateExists;
const getWindowWidth = () => {
  return window.innerWidth;
};
exports.getWindowWidth = getWindowWidth;
const scrollToElement = (targetElement, offset) => {
  const pos = targetElement.style.position;
  const top = targetElement.style.top;
  targetElement.style.position = 'relative';
  targetElement.style.top = offset || '-20px';
  targetElement.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
  targetElement.style.top = top;
  targetElement.style.position = pos;
};
exports.scrollToElement = scrollToElement;
const getWindowHeight = () => {
  return Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
};
exports.getWindowHeight = getWindowHeight;
const textSearchOnArrayOfObjectsBasedOnKey = (items, text, objectKey) => {
  text = text.toLowerCase().split(' ');
  return items.filter(function (item) {
    return text.every(function (el) {
      return item["".concat(objectKey)].toLowerCase().indexOf(el) > -1;
    });
  });
};
exports.textSearchOnArrayOfObjectsBasedOnKey = textSearchOnArrayOfObjectsBasedOnKey;
const filterGroupFlatten = configuration => {
  if (!isObject(configuration)) return [];
  const items = Object.values(configuration);
  const filterList = [];
  items.forEach(i => {
    var _a, _b, _c;
    if (i[0] && (((_a = i[0]) === null || _a === void 0 ? void 0 : _a.type) === 'RANGE' || ((_b = i[0]) === null || _b === void 0 ? void 0 : _b.type) === 'RELATIVE_DATE_RANGE' || ((_c = i[0].values) === null || _c === void 0 ? void 0 : _c.length))) {
      filterList.push(i[0]);
    }
  });
  return filterList;
};
exports.filterGroupFlatten = filterGroupFlatten;
function deepCopy(obj) {
  if (typeof obj !== 'object' || obj === null) {
    return obj;
  }
  if (obj instanceof Date) {
    return new Date(obj.getTime());
  }
  if (obj instanceof Array) {
    return obj.reduce((arr, item, i) => {
      arr[i] = deepCopy(item);
      return arr;
    }, []);
  }
  if (obj instanceof Object) {
    return Object.keys(obj).reduce((newObj, key) => {
      newObj[key] = deepCopy(obj[key]);
      return newObj;
    }, {});
  }
}
const formatToISOString = timestamp => timestamp.toISOString().replace(/.\d+Z$/g, 'Z');
/**
 * @param {*} token (jwtToken)
 * @returns decoded object
 */
exports.formatToISOString = formatToISOString;
const parseJwt = token => {
  try {
    return JSON.parse(atob(token.split('.')[1]));
  } catch (e) {
    return null;
  }
};
exports.parseJwt = parseJwt;
const merge = (target, source) => {
  for (const key of Object.keys(source)) {
    if (source[key] instanceof Object) {
      (0, _extends2["default"])(source[key], merge(target[key], source[key]));
    }
  }
  (0, _extends2["default"])(target || {}, source);
  return target;
};
exports.merge = merge;
const formatDateFromGivenDay = (selectedDate, relativeDate) => typeof selectedDate === 'number' ? selectedDate === 0 ? (0, _dateFns.startOfToday)() : selectedDate >= 1 ? (0, _dateFns.addDays)(relativeDate, selectedDate) : (0, _dateFns.subDays)(relativeDate, Math.abs(selectedDate)) : '';
exports.formatDateFromGivenDay = formatDateFromGivenDay;
const formatToRelativeDate = (date, relativeDateLocal) => {
  const differenceInDays = (0, _dateFns.differenceInCalendarDays)(date, relativeDateLocal);
  const dateABS = Math.abs(differenceInDays);
  const dateSuffix = dateABS > 1 ? 'days' : 'day';
  return differenceInDays === 0 ? 'Today' : differenceInDays >= 1 ? "".concat(dateABS, " ").concat(dateSuffix, " from today") : "".concat(dateABS, " ").concat(dateSuffix, " ago");
};
// export const copyToClipboard = (copyToClipboardString: string) => {
//   return copy(copyToClipboardString);
// };
/**
 * @param theme Takes the theme object from design tokens as an argument
 * @returns Converted theme object in hex
 * @description
 * convertDesignTokenFromRGBToHex
 * This function will converts the rbg & rgba properties to hex & hexa properties
 */
exports.formatToRelativeDate = formatToRelativeDate;
const convertDesignTokenFromRGBToHex = theme => {
  const themeHex = {};
  for (const [key, value] of Object.entries(theme)) {
    if (typeof value === 'string') {
      const isRGB = value.startsWith('rgb');
      if (!isRGB) {
        themeHex[key] = value;
      } else {
        themeHex[key] = value.startsWith('rgba') ? ColorConvert(value).hexa() : ColorConvert(value).hex();
      }
    } else if (typeof value === 'object') {
      const data = convertDesignTokenFromRGBToHex(value);
      themeHex[key] = data;
    }
  }
  return themeHex;
};
exports.convertDesignTokenFromRGBToHex = convertDesignTokenFromRGBToHex;
function getMatches(string) {
  string = string || '';
  // eslint-disable-next-line no-control-regex
  const reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g; // Used to match words composed of alphanumeric characters
  const matches = string.match(reAsciiWord) || [];
  return function (callback) {
    let initialValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return matches.reduce(callback, initialValue);
  };
}
function kebabCase(string) {
  const matches = getMatches(string);
  const result = matches((result, word, index) => {
    return result + (index ? '-' : '') + word.toLowerCase();
  });
  return result;
}
const findStyledColor = colorCode => {
  let value = {};
  if (typeof colorCode !== 'undefined' && colorCode.includes('.')) {
    const splitColors = colorCode === null || colorCode === void 0 ? void 0 : colorCode.split('.');
    const colorArr = (0, _extends2["default"])({}, _index["default"]);
    value = (0, _extends2["default"])({}, colorArr);
    splitColors === null || splitColors === void 0 ? void 0 : splitColors.forEach(key => {
      if ((value === null || value === void 0 ? void 0 : value[key]) !== null) {
        value = value === null || value === void 0 ? void 0 : value[key];
      }
    });
  } else if (typeof colorCode === 'string' && !colorCode.includes('.')) {
    return colorCode;
  }
  return value;
};
exports.findStyledColor = findStyledColor;
const customImagePattern = exports.customImagePattern = /^https:\/\/|\.(png|jpg|jpeg|svg|gif)$/;